import styled from "styled-components"

/**
 * A single scrolling row, for a section whose job is to be browsed rather than
 * surveyed. `CardGrid` stays for the opposite case — a filtered section holding
 * a handful of items reads better wrapped than as a short rail with dead space.
 *
 * Cards are a fixed basis rather than a fraction: a rail's whole point is that
 * the last one is cut off, which is the affordance that says it scrolls.
 */
export const CardRail = styled.ul.attrs({ role: "list" })`
  display: flex;
  align-items: start;
  gap: ${({ theme }) => theme.spacing.lg};
  margin: 0;
  /* Room under the cards for the horizontal scrollbar, which overlays the row otherwise. */
  padding: 0 0 ${({ theme }) => theme.spacing.md};
  list-style: none;
  overflow-x: auto;
  scroll-snap-type: x proximity;
  scroll-padding-inline-start: ${({ theme }) => theme.spacing.xxs};

  > li {
    flex: 0 0 ${({ theme }) => theme.railCardWidth};
    scroll-snap-align: start;
  }
`
